import React from 'react';

import Button from 'components/Button';

import styles from './Welcome.scss';

const Welcome = () => {
  const createAccountButtonProps = {
    className: styles.publishButton,
    primary: true,
    disabled: false,
    to: 'https://jobs.rainmakers.co',
    fullUrl: true,
  };

  return (
    <div className={styles.welcomeTop}>
      <div className={styles.welcomeContainer}>
        <h2 className={styles.welcomeHeader}>Thanks for Applying!</h2>
        <div className={styles.WelcomeMessage}>
          Your application is under review and a member of our team will be reaching out shortly.
          <br />
          <br />
          Interested in getting immediate access to our community of top sales talent?
        </div>
        <Button {...createAccountButtonProps}>Post a free job on the Rainmakers job board</Button>
      </div>
    </div>
  );
};

export default Welcome;
